import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/darulfeth-logo.png'
import _imports_1 from '@/assets/logo.png'


const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header-inner" }
const _hoisted_4 = { class: "main-nav" }
const _hoisted_5 = { class: "has-dropdown" }
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = { class: "header-right" }
const _hoisted_8 = { class: "lang-switch" }
const _hoisted_9 = { class: "mobile-lang-switch" }
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "footer-top" }
const _hoisted_12 = { class: "col brand" }
const _hoisted_13 = { class: "col links" }
const _hoisted_14 = { class: "col sectors" }
const _hoisted_15 = { class: "col contact" }
const _hoisted_16 = { class: "footer-bottom" }
const _hoisted_17 = { class: "policy-links" }
const _hoisted_18 = { href: "#" }
const _hoisted_19 = { href: "#" }

import { ref, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const { locale } = useI18n();
const isScrolled = ref(false);
const mobileMenuOpen = ref(false);

const changeLanguage = (lang: string) => {
  locale.value = lang;
};

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass({ scrolled: isScrolled.value })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "logo"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "DarulFeth"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("nav", _hoisted_4, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.home")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_5, [
                _createVNode(_component_router_link, { to: "/kurumsal" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.corporate")), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, { to: "/kurumsal/hakkimizda" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("nav.about")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/kurumsal/vizyon-misyon" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("nav.visionMission")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/faaliyet-alanlari" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.activities")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/projeler" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.projects")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/medya" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.media")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/iletisim" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.contact")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass({ active: _unref(locale) === 'tr' }),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLanguage('tr')))
              }, "TR", 2),
              _createElementVNode("span", {
                class: _normalizeClass({ active: _unref(locale) === 'en' }),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLanguage('en')))
              }, "EN", 2)
            ]),
            _createVNode(_component_router_link, {
              to: "/iletisim",
              class: "btn btn-primary sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("nav.contactUs")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("button", {
            class: "mobile-menu-toggle",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileMenuOpen.value = !mobileMenuOpen.value))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("span", null, null, -1),
            _createElementVNode("span", null, null, -1),
            _createElementVNode("span", null, null, -1)
          ]))])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-menu", { open: mobileMenuOpen.value }])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", {
          class: _normalizeClass({ active: _unref(locale) === 'tr' }),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (changeLanguage('tr')))
        }, "TR", 2),
        _createElementVNode("span", {
          class: _normalizeClass({ active: _unref(locale) === 'en' }),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (changeLanguage('en')))
        }, "EN", 2)
      ]),
      _createElementVNode("nav", null, [
        _createVNode(_component_router_link, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (mobileMenuOpen.value = false)),
          to: "/"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.home")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (mobileMenuOpen.value = false)),
          to: "/kurumsal"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.corporate")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (mobileMenuOpen.value = false)),
          to: "/faaliyet-alanlari"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.activities")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (mobileMenuOpen.value = false)),
          to: "/projeler"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.projects")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (mobileMenuOpen.value = false)),
          to: "/medya"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.media")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (mobileMenuOpen.value = false)),
          to: "/iletisim"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("nav.contact")), 1)
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("main", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[13] || (_cache[13] = _createElementVNode("img", {
              src: _imports_1,
              alt: "DarulFeth Footer",
              class: "footer-logo"
            }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("footer.desc")), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("footer.quickLinks")), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.home")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/kurumsal" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.corporate")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/projeler" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.projects")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/medya" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.media")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/iletisim" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("nav.contact")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("footer.activities")), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/faaliyet-alanlari/enerji" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("footer.energy")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/faaliyet-alanlari/teknoloji" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("footer.technology")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/faaliyet-alanlari/sanayi" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("footer.industry")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/faaliyet-alanlari/insaat" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("footer.construction")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/faaliyet-alanlari/mimarlik" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("footer.architecture")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("footer.contact")), 1),
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("footer.address")) + ":", 1),
              _cache[14] || (_cache[14] = _createTextVNode(" İstanbul, Türkiye ", -1))
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("footer.phone")) + ":", 1),
              _cache[15] || (_cache[15] = _createTextVNode(" +90 212 000 00 00 ", -1))
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("footer.email")) + ":", 1),
              _cache[16] || (_cache[16] = _createTextVNode(" info@darulfeth.com ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", null, " © " + _toDisplayString(new Date().getFullYear()) + " DarulFeth. " + _toDisplayString(_ctx.$t("footer.allRightsReserved")), 1),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.$t("footer.kvkk")), 1),
            _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.$t("footer.privacyPolicy")), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})